import { Component } from 'react';
import { withTranslation } from 'react-i18next';

export const FANOUT_PROMPTS_STORAGE_KEY = 'ai_tracking_fanout_prompts';

class AdditionalBox extends Component {
    constructor(props) {
        super(props);
        this.onAddToPrompts = this.onAddToPrompts.bind(this);
    }

    onAddToPrompts() {
        // Map the selected row ids back to their query text and stash them in
        // sessionStorage (not the URL) so the prompt generator's manual step can
        // pick them up and pre-fill the prompts textarea after navigation.
        const selectedQueries = (this.props.data ?? [])
            .filter((item) => this.props.selectedItems?.includes(item.id))
            .map((item) => item.query)
            .filter(Boolean);

        if (!selectedQueries.length) return;

        sessionStorage.setItem(FANOUT_PROMPTS_STORAGE_KEY, JSON.stringify(selectedQueries));
        window.location.href = '/ai-tracking/prompt-generator/';
    }

    render() {
        return (
            <>
                <div className="table-additional-view justify-content-end">
                    <div className="table-additional-view-btns ">
                        <button
                            className={'table-additional-view-btn '}
                            disabled={this.props.selectedItems.length === 0}
                            onClick={this.onAddToPrompts}
                        >
                            {this.props.t('ai_tracking.keyword_detail.fanoutQueries.track_prompts')}
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(AdditionalBox);
